<% var component = new Anvil.models.components.CheckBox(field) %>
<% if ('inline' in field && field.inline) { %>
<div anvil-component="<%- component.id %>" class="col-auto pr-0" style="padding-top:8px; padding-left:8px; padding-right:8px;">
	<div class="custom-control custom-checkbox">
		<input type="checkbox" class="custom-control-input" id="<%= form.name %>_<%= field.name %>" name="<%= field.name %>" value="1" <% if (form.data[field.name]) { %>checked<% } %> <% if ('attributes' in field) for (let key in field.attributes) { %><%- key %>="<%- field.attributes[key] %>" <% } %> />
		<label class="custom-control-label" for="<%= form.name %>_<%= field.name %>"><%= field.description %></label>
	</div>
</div>
<% } else { %>
<div anvil-component="<%- component.id %>" class="form-group row">
	<% if ('title' in field) { %>
	<div class="col-<%= ('label_width' in form.params) ? form.params.label_width : '4' %>">
		<label for="<%= form.name %>_<%= field.name %>" class="control-label"><%= field.title %></label>
	</div>
	<% } %>
	<div class="col">
		<div class="custom-control custom-checkbox">
			<input type="checkbox" class="custom-control-input" id="<%= form.name %>_<%= field.name %>" name="<%= field.name %>" value="1" <% if (form.data[field.name]) { %>checked<% } %> <% if ('attributes' in field) for (let key in field.attributes) { %><%- key %>="<%- field.attributes[key] %>" <% } %> />
			<label class="custom-control-label pl-1" for="<%= form.name %>_<%= field.name %>"><%= field.description %></label>
			<div class="invalid-feedback"></div>
		</div>
		<% if ('help' in field) { %><small class="form-text text-muted"><%- field.help %></small><% } %>
	</div>
</div>
<% } %>
